import { render, staticRenderFns } from "./StepWrapper.vue?vue&type=template&id=42c6ab04&"
import script from "./StepWrapper.vue?vue&type=script&lang=js&"
export * from "./StepWrapper.vue?vue&type=script&lang=js&"
import style0 from "./StepWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports